import React from 'react'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { Box, Card, CardActionArea, CardContent, Grid } from '@mui/material/'
import { CatalogCategoryText } from '@components/molecules/CatalogCategoryText'
import { FirstDepthCatalogCategoryFragment } from '@services/cloud/client'

type Props = {
  firstDepthCategory: FirstDepthCatalogCategoryFragment | null | undefined
}

export function CategoryList(props: Props) {
  const router = useRouter()

  return (
    <Grid container={true}>
      {props.firstDepthCategory?.secondDepthCategories?.map((category) => (
        <Grid key={category?.categoryId} xs={6} sm={4} md={4}>
          <Box m={1} textAlign="center">
            <Card>
              <CardActionArea
                onClick={() =>
                  router.push(
                    `/catalogs/category/${props.firstDepthCategory?.categoryId}/${category?.categoryId}`,
                  )
                }
              >
                <CardContent>
                  <Link
                    href={`/catalogs/category/${props.firstDepthCategory?.categoryId}/${category?.categoryId}`}
                  >
                    <CatalogCategoryText name={category?.name} length={category?.length} />
                  </Link>
                </CardContent>
              </CardActionArea>
            </Card>
          </Box>
        </Grid>
      ))}
    </Grid>
  )
}
